import styles from './PersonalDetailsUK.module.css';

const PrivacyPolicyUK = () => {
  return (
    <div className={styles.privacyPolicyAgreement}>
      <p>
        <strong>We use your personal information</strong> and that of your{' '}
        <strong>company directors, beneficial owners or guarantors</strong> in
        the following ways. (Please make them aware of this before you provide
        their information to us)
      </p>
      <ul>
        <li>
          <strong>
            We’ll share it with credit reference agencies to run soft credit and
            identity checks
          </strong>{' '}
          - this won’t affect your personal credit score
        </li>
        <li>
          <strong>We may ask you to provide a personal guarantee.</strong> We’ll
          only conduct credit checks on you and any other guarantors.
        </li>
        <li>
          <strong>We’ll share it with fraud prevention agencies</strong> - if we
          do spot fraud, you could be refused services, finance, or employment.
        </li>
        <li>
          <strong>We might record your calls with us.</strong>
        </li>
      </ul>
      <p>
        <strong>
          By clicking “Submit details” you agree to all of the above.
        </strong>{' '}
        If you’d like to find out more, check our{' '}
        <a
          href="https://www.iwoca.co.uk/privacy_policy/"
          target="_blank"
          rel="noreferrer"
        >
          privacy policy
        </a>
        .
      </p>
      <p>iwoca Ltd is the data controller.</p>
    </div>
  );
};

export default PrivacyPolicyUK;
